import { Card, FeaturedCard } from "./Cards"
import { allProjects, featuredProjects } from "../data/projectData"
import VideoModal from "./VideoModal"
import { useState } from "react"
import "./styles/projectsDark.css"

export default function ProjectsDark() {
  const [open, setOpen] = useState(false)
  const [videoUrl, setVideoUrl] = useState("")
  const [projectName, setProjectName] = useState("")
  const [image, setImage] = useState("")
  const [activeTab, setActiveTab] = useState("featured") // "featured" | "other"

  const handleCardClick = (project) => {
    setVideoUrl(project.video)
    setProjectName(project.name)
    setImage(project.imageSrc)
    setOpen(true)
  }

    const tabClass = (tab) =>
    `pj-tab${activeTab === tab ? " is-active" : ""}`

  return (
    <>
      <div className="pj-page">

        {/* Heading */}
        <div className="pj-header">
          <h1 className="pj-heading">Projects</h1>
        </div>

        {/* Tabs */}
        <div className="pj-tabs" role="tablist">
          <button
            className={tabClass("featured")}
            onClick={() => setActiveTab("featured")}
            role="tab"
            aria-selected={activeTab === "featured"}
          >
            Featured
          </button>
          <button
            className={tabClass("other")}
            onClick={() => setActiveTab("other")}
            role="tab"
            aria-selected={activeTab === "other"}
          >
            Other projects
          </button>
        </div>

        {/* Featured */}
        {activeTab === "featured" && (
          <div className="pj-hero-wrap">
            {featuredProjects.map((project) => (
              <FeaturedCard
                key={project.id}
                name={project.name}
                description={project.description}
                meta={project.meta}
                content={project.content}
                tags={project.tags}
                link={project.link}
                linkLabel={project.linkLabel}
                githubLink={project.githubLink}
                noLinkLabel={project.noLinkLabel}
                imageSrc={project.imageSrc}
                imageAlt={project.imageAlt}
                imageHeight={project.imageHeight}
                imageFit={project.imageFit}
                badge={project.badge}
              />
            ))}
          </div>
        )}

        {/* Other projects */}
        {activeTab === "other" && (
          <div className="pj-other-wrap">
            <div className="pj-grid">
              {allProjects.map((project) => (
                <Card
                  key={project.id}
                  name={project.name}
                  desc={project.desc}
                  content={project.content}
                  imageSrc={project.imageSrc}
                  imageAlt={project.imageAlt}
                  tags={project.tags}
                  link={project.link}
                  githubLink={project.githubLink}
                  colour={project.colour}
                  video={project.video}
                  badge={project.badge}
                  spotlight={project.spotlight}
                  onClick={() => handleCardClick(project)}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      <VideoModal
        projectName={projectName}
        open={open}
        setOpen={setOpen}
        video={videoUrl}
        image={image}
      />
    </>
  )
}